import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    success: false,
};

const postSocialsSlice = createSlice({
    name: 'postSocials',
    initialState,
    reducers: {
        setSuccessSocials: (state, action) => {
            state.success = action.payload;
        },
        setErrorSocials: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const postSocialsReducer = postSocialsSlice.reducer;
export const { setSuccessSocials,setErrorSocials } = postSocialsSlice.actions;
